import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class UploadService {
  private baseApiUrl: string;
  //private baseApiUrlupload: string;


  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseUploadUrl;
   // this.baseApiUrlupload = configurationService.BaseApiUrlUpload;
  }

  

// upload(data: FormData ,modelId: number): Observable < any > {
//     data.forEach((value,key) => {
//       console.log(key+" "+value);
//     });    

//     return this.httpClient.post < any > (this.baseApiUrl+`File?modelId=${modelId}`, data).pipe(
//       map((res: Response) => res),
//       catchError((err: any) => observableThrowError(err.message || 'Server error')));
//   }  



  // dataupload(data: FormData, modelId: number): Observable<any> {
  //   return this.httpClient.post(`${this.baseApiUrl}File?modelId=${modelId}`, data, {
  //     responseType: 'blob', // Handle Blob for both success and error
  //   }).pipe(
  //     map((response: Blob) => {
  //       if (response.type === 'application/json') {
  //         // Parse JSON response from Blob
  //         return new Response(response).json();
  //       } else {
  //         // If not JSON, assume it's an Excel file for errors
  //         throw response;
  //       }
  //     }),
  //     catchError((err) => {
  //       console.error('Error during upload:', err);
  //       return throwError(err); // Pass the error to the component
  //     })
  //   );
  // }
  


  upload(data: FormData, modelId: number,batchCode: string): Observable<any> {
    data.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
  
    return this.httpClient.post<any>(
      `${this.baseApiUrl}validationadata?modelId=${modelId}&batchCode=${batchCode}`,data
    ).pipe(
      map((res: Response) => res),
      catchError((err: any) => throwError(err.message || 'Server error'))
    );
  }

  dataupload(data: FormData, modelId: number,batchCode: string): Observable<any> {
    return this.httpClient.post(`${this.baseApiUrl}File?modelId=${modelId}&batchCode=${batchCode}`, data, {
      responseType: 'blob', // Handle Blob for both success and error
    }).pipe(
      map((response: Blob) => {
        if (response.type === 'application/json') {
          // Parse JSON response from Blob
          return new Response(response).json();
        } else {
          // If not JSON, assume it's an Excel file for errors
          throw response;
        }
      }),
      catchError((err) => {
        console.error('Error during upload:', err);
        return throwError(err); // Pass the error to the component
      })
    );
  }
  
  // validateFile(data: FormData, modelId: number): Observable<any> {
  //   data.forEach((value, key) => {
  //     console.log(`${key}: ${value}`);
  //   });
  
  //   return this.httpClient.post<any>(
  //     `${this.baseApiUrl}Filevalidate?modelId=${modelId}`,
  //     data
  //   ).pipe(
  //     map((res: Response) => res),
  //     catchError((err: any) => throwError(err.message || 'Server error'))
  //   );
  // }

  validateFile(data: FormData, modelId: number,repaymentDate:any): Observable<any> {
    data.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
  
    return this.httpClient.post<any>(
      `${this.baseApiUrl}Filevalidate?modelId=${modelId}&repaymentDate=${(repaymentDate)}`,
      data
    ).pipe(
      map((res: Response) => res),
      catchError((err: any) => throwError(err.message || 'Server error'))
    );
  }


  validateDataFile(data: FormData, modelId: number): Observable<any> {
    return this.httpClient.post(`${this.baseApiUrl}Filevalidate?modelId=${modelId}`, data, {
      responseType: 'blob', // Handle Blob for both success and error
    }).pipe(
      map((response: Blob) => {
        if (response.type === 'application/json') {
          // Parse JSON response from Blob
          return new Response(response).json();
        } else {
          // If not JSON, assume it's an Excel file for errors
          throw response;
        }
      }),
      catchError((err) => {
        console.error('Error during upload:', err);
        return throwError(err); // Pass the error to the component
      })
    );
  }

  uploadValidateddata1(data: FormData, modelId: number,batchCode: string): Observable<any> {
    return this.httpClient.post(
      `${this.baseApiUrl}validationadata?modelId=${modelId}&batchCode=${batchCode}`,data
    ).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  uploadValidateddata(modelId: number, batchCode: string): Observable<any> {
    const payload = {
      modelId: modelId,
      batchCode: batchCode
    };
  
    return this.httpClient.post(
      `${this.baseApiUrl}validationadata?modelId=${modelId}&batchCode=${batchCode}`,
      payload // Send the JSON object in the body
    ).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  
  // upload(data: FormData, modelId: number): Observable<any> {
  //   return this.httpClient.post(`${this.baseApiUrl}File?modelId=${modelId}`, data, {
  //     headers: new HttpHeaders(),
  //     responseType: 'blob' as 'json', // Handle both Blob (for errors) and JSON (for success)
  //   }).pipe(
  //     map((res: any) => {
     
  //       // Check if the response is a Blob and not JSON
  //       if (res instanceof Blob && res.type !== 'application/json') {
  //         throw res; // Throw the Blob for error handling
  //       }
  
  //       // Convert Blob to JSON if applicable
  //       if (res instanceof Blob) {
  //         return new Response(res).json(); // Parse JSON from Blob
  //       }
  
  //       return res; // Return the JSON response for success
  //     }),
  //     catchError((err) => {
  //       console.error('Error occurred during upload:', err);
  //       return throwError(err); // Pass the error to the subscriber
  //     })
  //   );
  // }
  
  
  
  
  
  
  


//old code
//   upload(data: FormData, modelId: number): Observable<any> {
//     // Log each item in the FormData for debugging
//     data.forEach((value, key) => {
//         console.log(`${key}: ${value}`);
//     });

//     // Construct the URL for the POST request
//     const url = `${this.baseApiUrl}File?modelId=${modelId}` ;
//     console.log(`Making a POST request to: ${url}`);

//     // Make the POST request and handle the response
//     return this.httpClient.post<any>(url, data).pipe(
//         map((res: any) => {
          
//             // Log the successful response for debugging
//             console.log('Upload response:', res);
//             return res;
//         }),
//         catchError((err: any) => {
//             // Log the error and rethrow it
           
//             console.error('Upload error:', err);
//             // alert(JSON.stringify(err))
//             return observableThrowError(err.message || 'Server error');
//         })  
//     );
// }


downloadCsv(modelId: number): Observable<Blob> {
    return this.httpClient.get(`${this.baseApiUrl}downloadcsv?modelId=${modelId}`, {
      responseType: 'blob' 
    });
  }

  
}
  
